import React, { useRef, useState, useEffect } from "react";
import NewWindowLogo from "assets/img/illustrations/NewWindowLogo";
import CustomerModal from "./CustomerModal";
import "../../main.css";
import CallIcon from "assets/svgs/table_call";
import Modal from "react-bootstrap/Modal";
import CallCut from "assets/svgs/call_cut.js";
import useStoreFeedback from "../customer_feedback/store/index";
import AscendingLogoGrey from "assets/img/illustrations/AscendingLogoGrey";
import DescendingLogoGrey from "assets/img/illustrations/DescendingLogoGrey";
import { Tooltip } from "react-bootstrap";
import { OverlayTrigger } from "react-bootstrap";
import NoData from "assets/svgs/no_data/NoData";
import { fourPlaceHolder, getFormattedDate } from "modules/utilities/utility";

function CustomerTable({
  data,
  isLoading,
  error,
  opa,
  handleSortUpdatedDate,
  isAction = false,
}) {
  const { fetchCall } = useStoreFeedback();

  const textRef = useRef(null);
  const [showCopiedModal, setShowCopiedModal] = useState(false);
  const [clickedIndexes, setClickedIndexes] = useState([]);
  const [sortedData, setSortedData] = useState(data);
  const [call, setCall] = useState("");
  const [callObj, setCallObj] = useState({});

  useEffect(() => {
    setSortedData(data);
  }, [data]);

  useEffect(() => {
    if (!call) {
      return;
    } else {
      fetchCall(callObj);
    }
  }, [call]);

  const handleCopy = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        setShowCopiedModal(true);
        setTimeout(() => {
          setShowCopiedModal(false);
        }, 500);
      })
      .catch((error) => {
        console.error("Failed to copy text to clipboard:", error);
      });
  };

  const handleCall = (index, item) => {
    setCallObj({
      phone_number: item?.user?.phone_number,
      case_id: item?.case_id,
      note: {},
    });
    if (!clickedIndexes.includes(index)) {
      setCall(index);
      setClickedIndexes([...clickedIndexes, index]);
    }
  };

  const headerName = [
    "Name",
    "Agent Name",
    "Order Display Id",
    "Cart Link",
    "Cart Link (3 months)",
  ];

  const headStyle = { flex: 1, verticalAlign: "middle" };
  const headStyleHeader = {
    flex: 1,
    position: "sticky",
    top: 0,
    zIndex: "",
    borderRadius: "10px",
  };

  const handleSortDate = () => {
    handleSortUpdatedDate();
  };

  return (
    <div
      className=" rounded mt-1 scrollable-table-feed w-100"
      style={{ minHeight: "20vh" }}
    >
      <table className="table px-2 table-hover">
        <thead className="pb-0 table-head mx-4" style={headStyleHeader}>
          <tr
            className="border d-flex"
            style={{
              position: "sticky",
              top: 0,
              zIndex: "5",
            }}
          >
            {headerName.map((header) => {
              return (
                <th
                  className="table-column flex-1 text-black mt-2  align-top "
                  style={headStyle}
                >
                  {header}
                </th>
              );
            })}
            <OverlayTrigger
              overlay={
                <Tooltip
                  style={{ position: "fixed" }}
                  id="overlay-trigger-example"
                >
                  {opa == "asc" ? (
                    <span className="fs-1">Click to sort ascending</span>
                  ) : opa == "dsc" ? (
                    <span className="fs-1">Click to sort Descending</span>
                  ) : (
                    <span className="fs-1">Click to cancel sort</span>
                  )}
                </Tooltip>
              }
            >
              <th
                style={headStyle}
                className="flex-1 align-top cursor-pointer text-black  mt-n2"
                onClick={handleSortDate}
              >
                <span
                  style={{ display: "inline-block", verticalAlign: "middle" }}
                >
                  <span> Last Updated</span>
                </span>
                <div
                  style={{
                    display: "inline-block",
                    verticalAlign: "middle",
                    paddingLeft: "1rem",
                  }}
                >
                  <div
                    className={
                      opa === ""
                        ? "opacity-100 mt-n2"
                        : opa === "asc"
                        ? "opacity-50 mt-n2"
                        : "opacity-100 mt-n2"
                    }
                  >
                    <AscendingLogoGrey />
                  </div>
                  <div
                    className={
                      opa === ""
                        ? "opacity-100 mt-n2"
                        : opa === "dsc"
                        ? "opacity-50 mt-n2"
                        : "opacity-100 mt-n2"
                    }
                  >
                    <DescendingLogoGrey />
                  </div>
                </div>
              </th>
            </OverlayTrigger>

            {isAction ? null : (
              <th
                className="table-column align-top mt-2 text-black flex-1 fs-1"
                style={{ minWidth: "12rem", position: "sticky", top: 0 }}
              >
                <span className="ps-5"> Action </span>
              </th>
            )}
          </tr>
        </thead>
        <tbody className="w-100">
          {isLoading ? (
            <>
              <tr>
            {fourPlaceHolder()}
              </tr>
            </>
          ) : data?.length !== 0 &&
            isLoading === false &&
            Array.isArray(sortedData) ? (
            Array.isArray(sortedData) &&
            sortedData?.map((item, index) => {
              const isClicked = clickedIndexes?.includes(index);
              return (
                <tr
                  id="table-row-value"
                  className={`d-flex border border-top-0  ${
                    (index % 10 === 9 || sortedData?.length - 1 === index) &&
                    `rounded-bottom`
                  }`}
                  key={index}
                  style={{ background: "#F9FAFD" }}
                >
                  <td className="flex-1 text-break">
                    <div className="d-flex  text-break align-items-center">
                      <span
                        className="cursor-pointer flex-1 text-break my-n2 text-primary "
                        style={headStyle}
                      >
                        {" "}
                        <CustomerModal
                          iconTab={<NewWindowLogo />}
                          userName={item?.user?.first_name}
                          record={item}
                        />
                      </span>
                    </div>
                  </td>
                  <td
                    className="flex-1 text-break m-0 text-black "
                    style={headStyle}
                  >
                    {item?.rep?.first_name || "-"}
                  </td>
                  <td
                    className="flex-1 text-break m-0 text-black "
                    style={headStyle}
                  >
                    {item?.order_display_id}
                  </td>
                  <td
                    className="flex-1 text-break  text-black "
                    style={headStyle}
                  >
                    <span
                      ref={textRef}
                      style={{
                        color: isClicked ? "red" : "green",
                        cursor: "pointer",
                      }}
                      onClick={() => handleCopy(item?.cart_link)}
                    >
                      <OverlayTrigger
                        overlay={
                          <Tooltip
                            style={{ position: "fixed" }}
                            id="overlay-trigger-example"
                          >
                            <div className="p-1">
                              Click to copy cart link
                            </div>
                          </Tooltip>
                        }
                      >
                        <span> Cart Link</span>
                      </OverlayTrigger>
                    </span>
                  </td>
                  <td
                    className="flex-1 text-break text-primary "
                    style={headStyle}
                  >
                    <span
                      ref={textRef}
                      style={{
                        color: isClicked ? "red" : "green",
                        cursor: "pointer",
                      }}
                      onClick={() => handleCopy(item?.cart_link_3m)}
                    >
                      <OverlayTrigger
                        overlay={
                          <Tooltip
                            style={{ position: "fixed" }}
                            id="overlay-trigger-example"
                          >
                            <div className="p-1 ">
                              Click to copy cart link
                            </div>
                          </Tooltip>
                        }
                      >
                        <span>Cart Link(3m)</span>
                      </OverlayTrigger>
                    </span>
                  </td>
                  <td
                    className="flex-1 text-break m-0 text-black "
                    style={headStyle}
                  >

                    {getFormattedDate(item?.updatedAt)}
                  </td>
                  {isAction ? null : (
                    <td
                      className="text-center cursor-pointer flex-1 text-break text-primary "
                      onClick={() => handleCall(index, item)}
                    >
                      <OverlayTrigger
                        overlay={
                          <Tooltip
                            style={{ position: "fixed" }}
                            id="overlay-trigger-example"
                          >
                            <div className="p-1 fs-1">Call</div>
                          </Tooltip>
                        }
                      >
                        <span className="pe-5">{isClicked ? <CallCut /> : <CallIcon />}</span>
                      </OverlayTrigger>
                    </td>
                  )}
                </tr>
              );
            })
          ) : (
            <div className="w-100 d-flex justify-content-center border bg-white">
              <h3 className="p-3 ">Data is not Available</h3>
              <span>
                <NoData />
              </span>
            </div>
          )}
        </tbody>
      </table>

      <Modal show={showCopiedModal} onHide={() => setShowCopiedModal(false)}>
        <Modal.Body>
          <span style={{ width: "5rem" }}>Link Copied!</span>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default CustomerTable;
